import React, { useEffect, useState } from 'react';
import Header from '../../master/SideBar';
import Nav from '../../master/NavBar';
import { gatepassadd } from '../../../api/GatePassService';
import { viewlist } from '../../../api/BatchService';
import { StudentList } from '../../../api/StudentServices';
import Swal from 'sweetalert2';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import { error } from 'jquery';
import { enquiryList } from '../../../api/Enquiry';

export default function CreateGatePass() {
    const navigate = useNavigate();
    const [studentType, setStudentType] = useState('');
    const handleTypeChange = (e) => { setStudentType(e.target.value); };
    const [batches, setBatches] = useState([]);
    const [Student, setStudent] = useState([]);
    const [Enquiry, setEnquiry] = useState([]);

    const handleBatches = async () => {
        try {
            const response = await viewlist();
            setBatches(response?.data?.batches || []);
        } catch (error) {
            console.error("Failed to fetch batches:", error);
        }
    };
    const handelStudent = async () => {
        try {
            const response = await StudentList();
            setStudent(response.data.data.data || "data not be found");
        } catch {
            Swal.fire('The Internet?', 'That thing is still around?', 'question');
        }
    };
    const handelenquiry = async () => {
        try {
            const response = await enquiryList();
            setEnquiry(response.data.data?.data)
        } catch { }
    }
    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData(e.target);
            const data = formData;
            const response = await gatepassadd(data);
            if (response?.data?.status === true) {
                Swal.fire({
                    icon: 'success',
                    title: response.data.message,
                    timer: 1000,
                });
                navigate('/GatePass')
            }
        } catch {
            Swal.fire({
                icon: 'error',
                text: error || 'Failed to add Gate Pass',


            })
        }
    };
    const [currentTime, setCurrentTime] = useState("");
    const [currentDate, setCurrentDate] = useState("");

    useEffect(() => {
        const now = new Date();

        // Format time as HH:MM (24-hour format)
        const time = now.toTimeString().slice(0, 5);

        // Format date as YYYY-MM-DD
        const date = now.toISOString().split("T")[0];

        setCurrentTime(time);
        setCurrentDate(date);
    }, []);
    return (
        <div className="layout-wrapper layout-content-navbar">
            <div className="layout-container">
                <Header />
                <div className="layout-page">
                    <Nav />
                    <div className="content-wrapper">
                        <div className="container-fluid py-4">
                            <div className="card shadow p-4">
                                <div className="row align-items-center">
                                    <div className="col-md-6">
                                        <h4 className="text-primary fw-bold">Create Gate Pass</h4>
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <Link
                                            to={"/GatePass"}
                                            className="btn btn-sm btn-outline-primary"
                                        >
                                            <i className="bi bi-arrow-left-circle me-1"></i> Back
                                        </Link>
                                        {/* <button onClick={() => navigate(-1)} className='btn btn-danger'>Back</button> */}
                                    </div>
                                </div>
                                <form onSubmit={handleSubmit}>
                                    <div className="row mb-3">
                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <select
                                                className="form-select"
                                                name="type"
                                                value={studentType}
                                                onChange={handleTypeChange}
                                                required
                                            >
                                                <option value="">Select Type</option>
                                                <option value="1">Admitted Students</option>
                                                <option value="0">Enquiry Students</option>
                                            </select>
                                            <label className="">Student Type</label>


                                        </div>

                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <select
                                                className="form-select"
                                                name="batch_id"
                                                onClick={handleBatches}
                                                required
                                            >
                                                <option value="">Select Batch</option>
                                                {batches.map((batch) => (
                                                    <option key={batch.id} name='batch_id' value={batch.id}>{batch.title}</option>
                                                ))}
                                            </select>
                                            <label className="">Batch</label>
                                        </div>

                                        <div className="col-md-4">
                                            {studentType === '1' && (
                                                <div className="mt-0 form-floating form-floating-outline">
                                                    <select
                                                        className="form-select"
                                                        name="student_id"
                                                        onClick={handelStudent}
                                                        required
                                                    >
                                                        {Array.isArray(Student) && Student.map((stu, index) => (
                                                            <option key={index} value={stu.id}>{stu.name}</option>
                                                        ))}
                                                    </select>
                                                    <label className="">Student </label>
                                                </div>
                                            )}

                                            {studentType === '0' && (
                                                <div className="mt-2 form-floating form-floating-outline">
                                                    <select
                                                        className="form-select"
                                                        name="enquiry_id"
                                                        onClick={handelenquiry}
                                                        required
                                                    >
                                                        {Array.isArray(Enquiry) && Enquiry.map((en, index) => (
                                                            <option key={index} value={en.id}>{en.name}</option>
                                                        ))}
                                                        <option value="">select Student</option>
                                                    </select>
                                                    <label>Enquiry Student</label>
                                                </div>
                                            )}
                                        </div>
                                    </div>

                                    {/* Reason and Time */}
                                    <div className="row">
                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <textarea
                                                className="form-control input-uppercase"
                                                name="reason"
                                                placeholder="Enter reason for gate pass"
                                                required
                                            ></textarea>
                                            <label className="">Reason</label>
                                        </div>


                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <input
                                                type="time"
                                                className="form-control"
                                                name="time"
                                                value={currentTime}
                                                required
                                                onChange={(e) => setCurrentTime(e.target.value)}
                                            />
                                            <label>Time</label>
                                        </div>
                                        <div className="col-md-4 form-floating form-floating-outline">
                                            <input
                                                type="date"
                                                className="form-control"
                                                name="date"
                                                value={currentDate}
                                                required
                                                onChange={(e) => setCurrentDate(e.target.value)}
                                            />
                                            <label>Date</label>
                                        </div>
                                    </div>
                                    <div className="text-end mt-5">
                                        <button type="submit" className="btn btn-primary">
                                            Submit Gate Pass
                                        </button>
                                    </div>

                                </form>
                            </div>
                        </div>
                    </div>
                </div></div>
        </div>

    );
}
